import { storageService } from '~/services/index.js'

export default ({ app }, inject) => {
  app.router.beforeEach(async (to, from, next) => {
    if (process.client) {
      const prevPages = JSON.parse(storageService.getItem('prevPages')) || []

      const excludedStrings = ['cashbox']

      if (prevPages.length === 0) {
        storageService.setItem('prevPages', JSON.stringify([from.path]))
      }
      else {
        if (from.name !== null && prevPages[prevPages.length - 1] !== from.path) {
          if (from.name === to.name) {
            next()
            return
          }

          prevPages.push(from.path)

          const filteredPagesArray = prevPages.filter(page =>
            !excludedStrings.some(excluded => page.includes(excluded))
          )

          const recentPages = filteredPagesArray.length > 10 ? filteredPagesArray.slice(-10) : filteredPagesArray

          if (filteredPagesArray[filteredPagesArray.length - 2] === to.path) {
            recentPages.splice(-2, 2)
          }
          else if (filteredPagesArray[filteredPagesArray.length - 1] === to.path) {
            recentPages.pop()
          }

          storageService.setItem('prevPages', JSON.stringify(recentPages))
        }
      }
    }
    next()
  })
  inject('smartStepBack', {
    push (params = {}) {
      const { defaultUrl } = params
      const prevPages =  JSON.parse(storageService.getItem('prevPages'))
      const DEFAULT_URL = defaultUrl || '/'

      if (prevPages.length) {
        const filterPrevPages = prevPages.filter((el) => {
          if (el !== app.context.route.path) {
            return el
          }
        })

        app.router.push({ path: filterPrevPages[filterPrevPages.length - 1] })
      }
      else {
        app.router.push({ path: DEFAULT_URL })
      }
    },
  })
}
